module.exports = __webpack_public_path__ + "static/media/rectangle-tblt-logged-in.3ca944ff.svg";